module.exports = __webpack_public_path__ + "akne_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_7_before.jpg
// module id = 928
// module chunks = 0